<div *ngIf="!confirmacion && !inscribir">
  <div class="modal-header">
    <h1>{{ data.Title }}</h1>
    <p class="image-text">{{ data.Provider }}</p>
  </div>
  <div class="modal-body">
    <p>
      <strong>Descripción: </strong><span [innerHTML]="data.description"></span>
    </p>
    <p>
      <strong>Fecha de Creación: </strong
      >{{ data.CreateDate | date: "dd/MM/yyyy" }}
    </p>
    <p><strong>Duración: </strong>{{ data.Duration }}</p>
    <p><strong>Precio: </strong>{{ data.Price }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="confirmacionFun()">
      Inscribirse
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="activeModal.close()">
      Cerrar
    </button>
  </div>
</div>

<!--Confirmacion-->
<div *ngIf="confirmacion && !inscribir">
  <div class="modal-header" *ngIf="confirmacion"><h1>Inscripción</h1></div>
  <div class="modal-body">
    <h4>
      ¿Esta seguro que desea Inscribirse en el evento
      <strong>{{ data.Title }}</strong> ?
    </h4>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="inscribirse(true)">
        Si, Quiero inscribirme
      </button>
      <button
        type="button"
        class="btn btn-danger"
        (click)="activeModal.close()">
        No, Cerrar
      </button>
    </div>
  </div>
</div>

<!--Inscribiendo-->
<div *ngIf="inscribir">
  <div class="modal-header" *ngIf="confirmacion"><h1>Inscripción</h1></div>
  <div class="modal-body">
    <ng-container *ngIf="!procesandoInscripcion">
      <app-loading-spinner-modal
        [accion]="'Registrando:'"
        [valUno]="data.ObjectId"
        [valDos]="data.Title"></app-loading-spinner-modal>
    </ng-container>
    <ng-container *ngIf="procesandoInscripcion && success">
      <div class="cont">
        <div class="success">
          <i class="fas fa-check-circle"></i>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="procesandoInscripcion && failure">
      <div class="cont">
        <div class="error">
          <i class="fas fa-times-circle"></i>
        </div>
      </div>
    </ng-container>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="activeModal.close()">
        Cerrar
      </button>
    </div>
  </div>
</div>
